import { supabase } from '../lib/supabase';

export interface Customer {
  id: string;
  company: string | null;
  name: string;
  email: string | null;
  phone: string | null;
  address: string | null;
  city: string | null;
  postal_code: string | null;
  country: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

export const customerService = {
  async getAllCustomers(): Promise<Customer[]> {
    try {
      const { data, error } = await supabase
        .from('customers')
        .select('*')
        .order('company', { ascending: true });

      if (error) {
        console.error('Supabase error:', error);
        throw new Error(error.message);
      }

      return data || [];
    } catch (error: any) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  },

  async getCustomerById(id: string): Promise<Customer | null> {
    try {
      const { data, error } = await supabase
        .from('customers')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw new Error(error.message);
      return data;
    } catch (error: any) {
      console.error('Error fetching customer:', error);
      throw error;
    }
  },

  async createCustomer(customerData: Partial<Customer>): Promise<Customer> {
    try {
      const { data, error } = await supabase
        .from('customers')
        .insert([customerData])
        .select()
        .single();

      if (error) {
        console.error('Supabase create error:', error);
        throw new Error(error.message);
      }

      return data;
    } catch (error: any) {
      console.error('Error creating customer:', error);
      throw error;
    }
  },

  async updateCustomer(id: string, customerData: Partial<Customer>): Promise<Customer> {
    try {
      const { data, error } = await supabase
        .from('customers')
        .update(customerData)
        .eq('id', id)
        .select()
        .maybeSingle();

      if (error) {
        console.error('Supabase update error:', error);
        throw new Error(error.message);
      }
      
      if (!data) {
        throw new Error(`Customer with id ${id} not found`);
      }

      return data;
    } catch (error: any) {
      console.error('Error updating customer:', error);
      throw error;
    }
  },

  async deleteCustomer(id: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('customers')
        .delete()
        .eq('id', id);

      if (error) throw new Error(error.message);
    } catch (error: any) {
      console.error('Error deleting customer:', error);
      throw error;
    }
  }
};
function CustomerInsert(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: CustomerInsert is not implemented yet.', args);
  return null;
}

export { CustomerInsert };